const DEFAULT_ENDPOINT = "/api/inquiries.php";

const FILE_FIELD_NAMES = new Set(["attachment", "resume"]);

function buildFormData(formType, data) {
  const formData = new FormData();
  formData.append("formType", formType);
  formData.append("submittedAt", new Date().toISOString());
  formData.append("source", window.location.pathname);

  Object.entries(data).forEach(([key, value]) => {
    if (value == null || value === "") {
      return;
    }

    if (value instanceof File) {
      formData.append(key, value, value.name);
      return;
    }

    if (FILE_FIELD_NAMES.has(key)) {
      return;
    }

    formData.append(key, String(value));
  });

  return formData;
}

export async function submitInquiry(formType, data) {
  const endpoint = process.env.REACT_APP_FORM_ENDPOINT || DEFAULT_ENDPOINT;
  const response = await fetch(endpoint, {
    method: "POST",
    body: buildFormData(formType, data),
  });

  let payload = {};
  try {
    payload = await response.json();
  } catch {
    payload = {};
  }

  if (!response.ok || payload.success === false) {
    throw new Error(payload.message || "Form submission failed");
  }

  return {
    method: "api",
    recipient: payload.recipient,
    messageId: payload.messageId,
  };
}
